import { cn } from '../../lib/utils';

interface FormSectionProps {
  icon?: React.ReactNode;
  iconBg?: string;
  title: string;
  description?: string;
  subtitle?: string;
  badge?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function FormSection({
  icon,
  iconBg,
  title,
  description,
  subtitle,
  badge,
  children,
  className,
}: FormSectionProps) {
  const subtext = subtitle ?? description;
  return (
    <div
      className={cn(
        'rounded-2xl border border-gray-200 bg-white shadow-sm overflow-hidden',
        className,
      )}
    >
      <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4">
        <div className="flex items-center gap-3">
          {icon && (
            <div
              className={cn(
                'flex h-9 w-9 shrink-0 items-center justify-center rounded-xl',
                iconBg ?? 'bg-brand-500 text-white',
              )}
            >
              {icon}
            </div>
          )}
          <div>
            <p className="text-sm font-semibold text-gray-900">{title}</p>
            {subtext && <p className="mt-0.5 text-xs text-gray-500">{subtext}</p>}
          </div>
        </div>
        {badge}
      </div>
      <div className="px-6 py-5">{children}</div>
    </div>
  );
}
